import { memo } from 'react';
import { useSelector } from 'react-redux';
import StarRating from '../../../components/StarRating';
import useVariation from '@hooks/useVariation';
import { useMediaQuery } from 'react-responsive';
import { Breakpoints } from '@settings';
import cx from '@utils/cx.util';

type Props = {
  tagline?: string;
  includeAggregateRating?: boolean;
};

const ProductHeader = ({ tagline, includeAggregateRating = true }: Props) => {
  const details = useSelector((state: any) => state.pdpItem?.details);
  const { displayNameOnPage, rating } = details || {};
  const isVariant = useVariation('Enhanced PDP');
  const isMobile = useMediaQuery({ maxWidth: Breakpoints.LG });

  if (!details) return null;

  return (
    <div className='tw-flex tw-flex-col'>
      <h1 className='tw-order-2 tw-mb-1 tw-mt-2 tw-text-left tw-font-body tw-text-2xl tw-font-extrabold tw-uppercase tw-leading-[26px] tw-text-body lg:tw-order-1 lg:tw-mb-3 lg:tw-mt-0'>
        {displayNameOnPage}
      </h1>

      {!!tagline && (
        <p
          className='tw-order-3 tw-mb-2 tw-text-left tw-text-sm tw-font-normal lg:-tw-mt-[5px] lg:tw-text-xl'
          dangerouslySetInnerHTML={{ __html: tagline }}></p>
      )}

      <div
        className={cx('tw-order-1 lg:tw-order-3 lg:tw-mb-auto lg:tw-flex lg:tw-items-center', {
          'tw-hidden': !isVariant,
        })}>
        <StarRating
          includeAggregateRating={includeAggregateRating}
          itemName={displayNameOnPage}
          reviewRating={rating.rating}
          reviewCount={rating.count}
          showReviewCount
          showReviewLabel={isMobile}
          starsColor='#1F1F1F'
          fontSize={isMobile ? '16px' : '22px'}
          labelClassName='tw-text-left !tw-text-[13px]'
        />
      </div>
    </div>
  );
};

export default memo(ProductHeader);
